import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';
import { getVendorCountByCategoryData } from 'utils/apiRequests';
import { useCategoryAndLevelContext } from './VendorCategoryLevelProvider';
import { generateToolTip } from 'utils/filterNames';

const VendorSpend = createContext();

export const VendorSpendProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [chartData, setChartData] = useState([]);

	const { categoryAndLevel } = useCategoryAndLevelContext();

	useEffect(
		() => {
			getData();
		},
		[categoryAndLevel]
	);

	const getData = () => {
		if (categoryAndLevel.level <= 4) {
			setIsLoading(true);
			const payload = {
				categoryName: categoryAndLevel.categoryName,
				categoryLevel: categoryAndLevel.level,
			};
			getVendorCountByCategoryData(payload)
				.then(response => {
					if (response.succeeded) {
						const { data: seriesData } = response;
						if (response.data !== null) {
							setChartData(
								seriesData.map(obj => ({
									name: obj.category,
									value: obj.spend,
									colorValue: obj.spend,
									// tooltip: generateToolTip({
									// 	...obj,
									// 	['spend']: spendFormatter(obj.spend),
									// }),
								}))
							);

							setIsLoading(false);
						} else {
							setChartData([]);
							setIsLoading(false);
						}
					} else {
						setChartData([]);
						setIsLoading(false);
					}
				})
				.catch(() => setIsLoading(false));
		}
	};

	const memoizedValue = useMemo(
		() => {
			return {
				isLoading,
				chartData,
				// categoryAndLevel,
				// // handleColumnClick,
			};
		},
		[isLoading, chartData, categoryAndLevel]
	);
	return (
		<VendorSpend.Provider value={memoizedValue}>
			{children}
		</VendorSpend.Provider>
	);
};

export const useVendorSpendContext = () => {
	return useContext(VendorSpend);
};
